/**
 * Created by rak on 4/28/2015.
 */

'use strict';

angular.module('dashboard.vehicleMap', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('vehicleMapWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.deviceMap.deviceMapTitle';
          },
          description: function () {
            return 'dashBoard.fleetManagement.deviceMap.description';
          }
        },
        controller: 'vehicleMapCtrl',
        templateUrl: 'components/dashboard/vehicleMap/vehicleMapWidget.tpl.html',
        isSingleInstance: true,
        config: {
          height: 400
        },
        edit: {
          templateUrl: 'components/dashboard/vehicleMap/vehicleMapEdit.tpl.html',
          reload: false,
          controller: 'vehicleMapEditCtrl'
        }
      });
  }).service('vehicleMapWidgetService', function () {

    var _crrentTabName = '';
    var _lastMapUrl = {
      dashboardName: '',
      isDataFromTab: false,
      tabNumber: null,
      mapURL: ''
    };
    var _isWidgetInitialized = false;
    var _groupId = '';

    this.getCurrentTabName = function () {
      return _crrentTabName;
    };

    this.setCurrentTabName = function (tabName) {
      _crrentTabName = tabName;
    };

    this.setLatMapUrl = function (mapUrl) {
      _lastMapUrl = mapUrl;
      // Store group ID if provided in the mapUrl object
      if (mapUrl && mapUrl.groupId !== undefined) {
        _groupId = mapUrl.groupId;
      }
    };

    this.getLastMapUrl = function () {
      return _lastMapUrl;
    };
    this.isWigetInitialized = function () {
      return _isWidgetInitialized;
    };
    this.setWigetInitialized = function (value) {
      _isWidgetInitialized = value;
    };

    this.getGroupId = function () {
      return _groupId;
    };

    this.setGroupId = function (groupId) {
      _groupId = groupId;
    };

  }).controller('vehicleMapCtrl', function ($scope, stateManagerService, AuthenticationService, base64, $rootScope, crudService, $timeout, commonTrackService, config, vehicleMapWidgetService, $window) {
    $scope.height = config.height;
    $scope.height = vehicleMapWidgetService.isWigetInitialized() ? $window.innerHeight - 200 : config.height;
    var _notFoundURL = '404.html';
    $scope.mapUrl = '';
    $scope.groupId = vehicleMapWidgetService.getGroupId() || '';
    $scope.isWidgetPostInitFinished = false;



    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      });
    };
    loadFleetServerDetails().then(function () {
      vehicleMapWidgetService.setWigetInitialized(true);

    }).finally(function () {
      // if Parent not Rendered Then the 'vehicleMap_req_current_context' is lost so try mutiple times to get valid Response or Request
      $timeout(function () {
        $rootScope.$broadcast('vehicleMap_req_current_context');
      }, 0);

    });

    // if under a model dialog / initial loading sent a event Parent widget to get the current selected row/other information

    // Response from current Parent Widget for the request event 'leetMap_req_current_context'
    /**
     * Try to get the parent selected  row / related  data if not avilable will try 20 times in the interval of 50 milli seconds each
     */
    var maxGetInitialDataRetries = 30;
    var currentSelectedRowResEvent = $scope.$on('vehicleMap_res_current_context', function (event, data) {
      $scope.isResponseRecievedFromParent = true;
      --maxGetInitialDataRetries;
      var tmpLastTabIURL = vehicleMapWidgetService.getLastMapUrl();
      if (!_.isEmpty(data.currentWidgetContextData.selectedRow)) { // id parent widget loaded .

       // console.log(data.currentWidgetContextData);
        $scope.isWidgetPostInitFinished = true;
        switch (data.dashboardName) {
          case 'dashboard.vehicleList':
          case 'dashboard.driverWrkHrsDashboard':
          case 'dashboard.fmsDashboard':
          case 'dashboard.tachohistory':
            switch (data.tabNumber) { // for all dashboard intial tab '0' show cu
              case 0:
                rowSelectHandler(data.currentWidgetContextData);
                break;
              case 1:
              case 2:
              case 3: // if not default tab then the parent is already loaded and can get data from vehicleMapWidgetService
                if (tmpLastTabIURL && tmpLastTabIURL.dashboardName === data.dashboardName) {
                  if (data.isDataFromTab === tmpLastTabIURL.isDataFromTab && data.tabNumber === tmpLastTabIURL.tabNumber) {

                    $scope.mapUrl = tmpLastTabIURL.mapURL;
                    // to show loading progress
                  }
                } else {
                  $scope.mapUrl = _notFoundURL;
                }
                break;

            }

            break;
          case 'dashboard.tachoDownloadStatusList':
            mapEventReportUpdate(data);
            break;
        }


      } else if (!$scope.isWidgetPostInitFinished) {
        if (maxGetInitialDataRetries > 0) {
          $timeout(function () {
            $rootScope.$broadcast('vehicleMap_req_current_context');
          }, 100);
        } else {
          console.warn('Max Retries exceeded to get the current Parent data for VehicleMap widget..');
          $scope.isWidgetPostInitFinished = true;
          /* if (data.isDataAvailable === false) { // To show Report not autorized if the parent Widget Report is not Autorized

            $scope.isNotAuthorized = true;
            return;
          } */
          $scope.mapUrl = _notFoundURL;
          currentSelectedRowResEvent();
        }
        // Repeatedly try to get the data from parent .
      }


    });
    // (scl-1340) used to trigger specific updates with regards to telltale specific map events
    var telltaleDataUpdate = $scope.$on('telltaleDataUpdate', function (event, data) {
      $scope.isWidgetPostInitFinished = true;

      _functionUpdateMapUrl(data.deviceId);
      vehicleMapWidgetService.setLatMapUrl({
        dashboardName: data.dashboardName,
        isDataFromTab: data.isDataFromTab,
        tabNumber: data.tabNumber,
        mapURL: $scope.mapUrl,
        groupId: $scope.groupId
      });


    });


    var eventMapUpdateEvent = $scope.$on('eventReportMapUpdate', function (event, data) {

      if ($scope.isWidgetPostInitFinished) {
        mapEventReportUpdate(data);
      }

    });

    var rowSlectedEvent = $scope.$on('rowSelected', function (event, data) {

      if ($scope.isWidgetPostInitFinished) {
        rowSelectHandler(data);
      }

    });

    function rowSelectHandler(data) {
      if (data.updateMapUrl === undefined || data.updateMapUrl) {
        _functionUpdateMapUrl(data.selectedRow !== null && data.selectedRow !== undefined ? data.selectedRow.deviceid : null);
        vehicleMapWidgetService.setLatMapUrl({
          dashboardName: data.dashboardName,
          isDataFromTab: data.isDataFromTab,
          tabNumber: data.tabNumber,
          mapURL: $scope.mapUrl,
          groupId: $scope.groupId
        });

      }
    }

    // user to update event report specific event map updates.
    var mapEventReportUpdate = function (data){
      $scope.isWidgetPostInitFinished = true;
      $scope.mapUrl = '';
      vehicleMapWidgetService.setCurrentTabName(data.tabName);
      if (data.repoVehicle) {
        $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', data.repoVehicle, '', data.startDate, data.endDate);
        if (data.showPushpins) {
          $scope.mapUrl += '&pushpins_dsa=all';
          }
      }else {
        _functionUpdateMapUrl(data.deviceId !== null && data.deviceId !== undefined ? data.deviceId : null);
      }

      vehicleMapWidgetService.setLatMapUrl({
        dashboardName: data.dashboardName,
        isDataFromTab: data.isDataFromTab,
        tabNumber: data.tabNumber,
        mapURL: $scope.mapUrl,
        groupId: $scope.groupId
      });
    };


    $scope.$on('tacho_event_history_row_select', function (event, data) {

      if ($scope.isWidgetPostInitFinished) {
        rowSelectHandler(data);
      }

    });


    var vehicleGroupChengedEvent = $scope.$on('vehicleGroupChanged', function (event, data) {
      if ($scope.isWidgetPostInitFinished) {
        $scope.groupId = data.selectedVehicleGroup || '';
        vehicleMapWidgetService.setGroupId($scope.groupId);
        _functionUpdateMapUrl(data.selectedRow !== null && data.selectedRow !== undefined ? data.selectedRow.deviceid : null);

        vehicleMapWidgetService.setLatMapUrl({
          dashboardName: data.dashboardName,
          isDataFromTab: data.isDataFromTab,
          tabNumber: data.tabNumber,
          mapURL: $scope.mapUrl + '&group=' + $scope.groupId,
          groupId: $scope.groupId
        });

      }

    });


    var tabEvent = $scope.$on('tabEvent', function (event, data) {
      $scope.isWidgetPostInitFinished = true;
      $scope.mapUrl = '';
      vehicleMapWidgetService.setCurrentTabName(data.tabName);
      if (data.tabName !== 'lastLocation' && data.tabName !== 'FMSVehicle' && data.tabName !== 'vehicleTellTale') {  // TODO : REMOVE tab specific coupling use property based
        if (data.repoVehicle) {
          $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', data.repoVehicle, '', data.startDate, data.endDate);
          if (data.tabName === 'vehicleOrders') {
            $scope.mapUrl += '&pushpins_dsa=all';
          }
        } else {
          $scope.mapUrl = _notFoundURL;
        }
      } else {
        _functionUpdateMapUrl(data.deviceId !== null && data.deviceId !== undefined ? data.deviceId : null);
      }
      vehicleMapWidgetService.setLatMapUrl({
        dashboardName: data.dashboardName,
        isDataFromTab: data.isDataFromTab,
        tabNumber: data.tabNumber,
        mapURL: $scope.mapUrl,
        groupId: $scope.groupId
      });

    });

    var orderRowSelectedEvnt = $scope.$on('ordersRowSelected', function (event, data) {
      $scope.isWidgetPostInitFinished = true;
      $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', data.repoVehicle, '', data.startDate, data.endDate);
      $scope.mapUrl += '&pushpins_dsa=all&workorderid=' + data.orderid;
      vehicleMapWidgetService.setLatMapUrl({
        dashboardName: data.dashboardName,
        isDataFromTab: data.isDataFromTab,
        tabNumber: data.tabNumber,
        mapURL: $scope.mapUrl,
        groupId: $scope.groupId
      });

    });

    function _functionUpdateMapUrl(deviceID) {
      if (deviceID) {
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, '&page=map.device.full&device=' + deviceID, 'vehicleMap');
      } else {
        return;
      }
      var currentGroupId = $scope.groupId || vehicleMapWidgetService.getGroupId() || '';
      $scope.mapUrl += '&geoZoneWorkOrder=true&required_session=false&group=' + currentGroupId;
    }

    $scope.$on('$locationChangeStart ', function () {
      vehicleMapWidgetService.setWigetInitialized(false);
    });

    $scope.$on('$destroy', function () {
      orderRowSelectedEvnt();
      tabEvent();
      vehicleGroupChengedEvent();
      rowSlectedEvent();
      currentSelectedRowResEvent();
      telltaleDataUpdate();
      eventMapUpdateEvent();
    }
    );
    $scope.vehicleMapLoadEvent = function () {
      $scope.isWidgetPreInitFinished = true; // Pre init animation must disaaper
      //console.log('iframe "#vehicleMap" loaded ....');
    };


  }).controller('vehicleMapEditCtrl', function ($scope, config) {
    $scope.fleetMap = {
      height: config.height
    };
    $scope.$watch('fleetMap.height', function (height) {
      if (height) {
        config.height = height;
      }
    });
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleMap/vehicleMapWidget.js